// extracted by mini-css-extract-plugin
export default {"label":"ZDGX9jT4kIyDvIvx36Bu","container":"DHlkBivf8dTQhH9BRk74"};